import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
const learnings = ['Cómo identificar el apego emocional y entender por qué tu mente no puede soltar', 'Por qué sientes ansiedad emocional, vacío y miedo al abandono', 'Las 4 áreas que el apego está drenando ahora mismo: SALUD — AMOR — DINERO — ESPIRITUALIDAD', 'Cómo empezar a recuperar tu autoestima y tu paz interior', 'Qué hacer para dejar de depender emocionalmente y volver a sentir claridad', 'Cómo comenzar a reconstruirte emocionalmente desde el Método F.O.D.A'];
export function WhatYoullLearn() {
  return <section className="py-24 px-6" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 text-cream" data-id="element-173">
            En este entrenamiento gratuito{' '}
            <span className="italic text-terracotta" data-id="element-174">descubrirás:</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-175">
          {learnings.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-teal-900 rounded-2xl shadow-sm border border-cream/10" data-id="element-176">
              <CheckCircle2 className="w-6 h-6 text-terracotta flex-shrink-0 mt-0.5" data-id="element-177" />
              <p className="text-lg text-cream/90 leading-relaxed" data-id="element-178">{item}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center mt-16" data-id="element-179">
          <CTAButton data-id="element-180" />
        </motion.div>
      </div>
    </section>;
}